// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + {"608": "2831dd498c71edce","709": "843fbb7150146f71","816": "d78664bf39bf4fa8",}[chunkId] + ".js"
}